module.exports = __webpack_public_path__ + "static/media/vuejs.69cedcf3.svg";